import script from "./chestUserDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./chestUserDetails.vue?vue&type=script&setup=true&lang=ts"

import "./chestUserDetails.vue?vue&type=style&index=0&id=93b94658&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93b94658"]])

export default __exports__